module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"new":"Новое!","selfRefused":"Отказался"}}')
  delete Component.options._Ctor
}
